import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { CartItem } from '@eti/components';
import { price as priceUtil } from '@eti/utils';

const productStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.75rem;
  padding-left: 1.5rem;

  [dir='rtl'] & {
    padding-left: 0;
    padding-right: 1.5rem;
  }
`;

const productsStyles = css`
  margin-top: 0.5rem;
`;

const setKey = (index) => `key-${index}`;

const iconStyles = css`
  height: 1rem;
  width: 1rem;
`;

const ReceiptProductBundle = ({
  component: Component = CartItem,
  id,
  title,
  price,
  products,
  viewMode = '',
}) => (
  <Component
    dataTestId={`cart-bundle-${id}${viewMode}`}
    hasToggle={products.length > 0}
    icon="product-bundle"
    iconStyles={iconStyles}
    isOpenByDefault
    price={priceUtil.formatPrice(price)}
    priceDataTestId={`cart-bundle-${id}-price${viewMode}`}
    title={title}
  >
    {products.length > 0 && (
      <div className={productsStyles}>
        {products.map((product, index) => (
          <div className={productStyles} key={setKey(index)}>
            <span>{product.name}</span>
          </div>
        ))}
      </div>
    )}
  </Component>
);

ReceiptProductBundle.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  id: PropTypes.string,
  price: PropTypes.number,
  products: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  viewMode: PropTypes.string,
};

export default ReceiptProductBundle;
